import magnifiAPIInstance from "./apiInstance";

export const settingsAPIs = {
  getSettings: ({ payload, entityId, clientId }) =>
    magnifiAPIInstance.get(`/accounts/settings/${entityId}`, {
      params: clientId ? { clientId } : null,
      payload,
    }),

  createFolders: ({ payload }) => magnifiAPIInstance.post(`/folder_name`, payload),
};
